import React, {Component} from 'react';
import PropTypes from 'prop-types';
import GenericModal from './generic_modal';
import {injectIntl} from 'react-intl';
import Util from '../../forecast-app/shared/util/util';
import Person from '../../forecast-app/shared/components/person/person';
import {profilePicSrc} from '../../constants';
import UpdateTimeRegMutation from '../../mutations/update_time_registration_mutation.modern';
import FixedRangePicker from '../../components/new-ui/date-controls/fixed_range_picker';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import uuid from 'uuid';
import Dropdown from '../../forecast-app/shared/components/dropdowns/dropdown';
import HoursInput from '../../forecast-app/shared/components/inputs/hours-input/hours_input_view';
import {BUTTON_COLOR} from '../../constants';
import {showModal, MODAL_TYPE} from '../../forecast-app/shared/components/modals/generic_modal_conductor';

class TimeRegistrationModal extends Component {
	constructor(props) {
		super(props);
		this.hourInputUuid = uuid.v4();
		let timeRegistration;
		let date;
		timeRegistration = this.props.timeReg;
		date = Util.CreateNonUtcMomentDate(timeRegistration.year, timeRegistration.month, timeRegistration.day);

		timeRegistration.taskId = props.task.id;

		this.state = {
			datePickerValue: date,
			newTimeReg: timeRegistration,
			timeInput: (timeRegistration.minutesRegistered || 0) / 60,
			//harvestTaskId: this.props.harvestTaskId || null,
			harvestTaskId: this.props.timeReg.harvestTask ? this.props.timeReg.harvestTask.id : null,
			selectedUnit4Activity: this.props.timeReg.unit4ActivityId ? {value: this.props.timeReg.unit4ActivityId, label: this.props.timeReg.unit4ActivityName} : null,
			unit4ActivityOptions: this.props.timeReg.unit4ActivityId ? [{value: this.props.timeReg.unit4ActivityId, label: this.props.timeReg.unit4ActivityName}] : [],
			unit4Loading: false,
		};
	}

	saveEditTimeReg() {
		const onSuccess = result => {
			if (result.updateTimeReg && result.updateTimeReg.errors && result.updateTimeReg.errors.length === 1 && result.updateTimeReg.errors[0] === 'TIME_REGISTRATION_IN_LOCKED_PERIOD') {
				showModal({
					type: MODAL_TYPE.WARNING_DATE_LOCKED,
				});
			} else {
				createToast({
					duration: 2500,
					message: this.props.intl.formatMessage({id: 'time_page.time_reg_updated'}),
				});
				this.props.closeModal();
			}
		};

		const timeReg = this.state.newTimeReg;
		Util.CommitSchedulingModalUpdate(
			UpdateTimeRegMutation,
			{
				id: timeReg.id,
				projectId: timeReg.projectId,
				taskId: timeReg.taskId,
				minutesRegistered: timeReg.minutesRegistered,
				day: timeReg.day,
				month: timeReg.month,
				year: timeReg.year,
				removeOthersForTheDay: timeReg.removeOthersForTheDay,
				notes: timeReg.notes,
				harvestTaskId: this.state.harvestTaskId,
				unit4ActivityId: this.state.selectedUnit4Activity ? this.state.selectedUnit4Activity.value : null,
				unit4ActivityName: this.state.selectedUnit4Activity ? this.state.selectedUnit4Activity.label : null,
				newFormat: true,
			},
			onSuccess
		);
	}

	handleHoursChange(newHours) {
		this.setState(prevState => ({
			newTimeReg: {
				...prevState.newTimeReg,
				minutesRegistered: newHours * 60,
			},
			timeInput: newHours,
		}));
	}

	handleDateChange(date) {
		this.setState(prevState => ({
			newTimeReg: {
				...prevState.newTimeReg,
				year: date.year(),
				month: date.month() + 1,
				day: date.date(),
			},
		}));
	}

	handleNotesChange(e) {
		const note = e.target ? e.target.value : '';
		this.setState(prevState => ({
			newTimeReg: {
				...prevState.newTimeReg,
				notes: note,
			},
		}));
	}

	onHoursInputEnter() {
		this.saveEditTimeReg();
		this.props.closeModal();
	}

	handleSelectHarvestTask(e) {
		this.setState({harvestTaskId: e.value});
		if (this.timeEntriesTile) this.focusTimeEntriesTile();
	}

	closeModal(close) {
		if (close) {
			this.props.closeModal();
		}
	}

	handleSelectUnit4Activity(e) {
		this.setState({selectedUnit4Activity: e});
		if (this.timeEntriesTile) this.focusTimeEntriesTile();
	}

	fetchUnit4Activities() {
		const {task} = this.props;
		if (task && task.project.unit4Project && task.project.id) {
			if (this.state.unit4Loading) {
				return;
			}
			this.setState({unit4Loading: true});
			const headers = new Headers();
			headers.append('Content-Type', 'application/json');
			const init = {headers: headers, credentials: 'include'};
			fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'unit4_activities/' + task.project.id, init)
				.then(result => result.json())
				.then(activities => {
					this.setState({unit4Loading: false, unit4ActivityOptions: activities.map(activity => ({label: activity.name, value: activity.id}))});
				})
				.catch(e => {
					this.setState({unit4Loading: false, unit4ActivityOptions: []});
				});
		} else {
			this.setState({unit4Loading: false, unit4ActivityOptions: []});
		}
	}

	render() {
		const {formatMessage} = this.props.intl;
		const {timeReg, task} = this.props;
		const {person} = timeReg;
		const showHarvest = timeReg.harvestTask || (task && task.project.harvestProject);
		const showUnit4 = timeReg.unit4ActivityId || (task && task.project.unit4Project && task.project.unit4Project.activitiesEnabled);
		const content = (
			<div className="time-registration-editor-modal-content">
				<Person
					key={person.id}
					name={person.fullName ? person.fullName : `${person.firstName} ${person.lastName}`}
					showName={false}
					showRole={false}
					imageSrc={person.profilePictureId ? profilePicSrc(person.profilePictureId) : null}
					imageSize="large"
				/>
				<div className="time-registration-hour-date">
					<div className={'time-registration-hour'}>
						<label id={'label-' + this.hourInputUuid} className={'label'} htmlFor="time-registration-hour-input">
							{formatMessage({id: 'common.hours'})}
						</label>
						<div className={'time-registration-hour-input'}>
							<HoursInput id="time-registration-hour-input" value={this.state.timeInput} minuteLimit={1440} mutation={v => this.handleHoursChange(v)}></HoursInput>
						</div>
					</div>
					<div className="time-registration-date">
						<label className={'label'}>{formatMessage({id: 'common.date'})}</label>
						<FixedRangePicker
							rangeType={'day'}
							customBackgroundColor={'#f3f3f3'}
							calendarOffsetX={-98}
							startDate={this.state.datePickerValue.clone()}
							locale={this.props.locale}
							showEmptyDate={true}
							handleDateRangeChange={date => this.handleDateChange(date)}
							startDateLimite={this.props.lockedDate && this.props.lockedDate.clone().add(1, 'd')}
						/>
					</div>
				</div>
				{showHarvest ? (
					<div className="integration-task-select">
						<Dropdown
							ref={dropdown => (this.harvest_task_dropdown = dropdown)}
							value={this.state.harvestTaskId}
							options={this.props.harvestTaskOptions}
							onChange={this.handleSelectHarvestTask.bind(this)}
							label={formatMessage({id: 'card_modal.harvest_task'})}
							placeholder={formatMessage({id: 'card_modal.harvest_task_placeholder'})}
							customHeight={30}
							customClasses="harvest-task-dropdown"
							integrationDropdown={true}
						/>
					</div>
				) : null}

				{showUnit4 ? (
					<div className="integration-task-select">
						<Dropdown
							ref={dropdown => (this.unit4_activity_dropdown = dropdown)}
							value={this.state.selectedUnit4Activity ? this.state.selectedUnit4Activity.value : null}
							options={this.state.unit4ActivityOptions}
							onChange={this.handleSelectUnit4Activity.bind(this)}
							label={formatMessage({id: 'integrations.unit4_activity'})}
							placeholder={formatMessage({id: 'integrations.unit4_activity_placeholder'})}
							customHeight={30}
							onClick={this.fetchUnit4Activities.bind(this)}
							integrationDropdown={true}
							integrationLoading={this.state.unit4Loading}
							integrationRetryToFetch={this.fetchUnit4Activities.bind(this)}
						/>
					</div>
				) : null}

				<div className="notes-container">
					<div className="note">
						<div className="note-text">
							<label className={'label'} htmlFor="time-registration-notes">
								{formatMessage({id: 'common.notes'})}
							</label>
							<textarea
								id="time-registration-notes"
								maxLength={this.props.viewer.company.characterLimit > -1 ? this.props.viewer.company.characterLimit : 999}
								disabled={this.state.newTimeReg.economicTimeId}
								rows={5}
								cols={40}
								placeholder={formatMessage({id: 'overview_time.write_your_notes'})}
								defaultValue={this.state.newTimeReg.notes}
								onChange={this.handleNotesChange.bind(this)}
							/>
						</div>
					</div>
				</div>
			</div>
		);
		return (
			<GenericModal
				defaultCallback={undefined}
				closeModal={this.closeModal.bind(this)}
				buttons={[
					{text: formatMessage({id: 'common.cancel'}), color: BUTTON_COLOR.WHITE, callback: this.closeModal.bind(this, true)},
					{
						text: formatMessage({id: 'common.save'}),
						color: BUTTON_COLOR.GREEN,
						callback: this.saveEditTimeReg.bind(this),
						disabled: typeof this.state.timeInput !== 'number' || this.state.timeInput > 24,
					},
				]}
				content={content}
				headerText={formatMessage({id: 'time_registration.edit.header'})}
				modalRef={this.props.modalRef}
			/>
		);
	}
}

TimeRegistrationModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	isEdit: PropTypes.bool,
};

export default injectIntl(TimeRegistrationModal);
